import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const UGL_LOGO = "/ugl-logo.png";

export default function BonusPage() {
  return (
    <div className="h-screen flex flex-col bg-[#0f1d32]">
      {/* Header compatto */}
      <header className="bg-[#001830]/90 border-b border-white/10 flex-shrink-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-12">
          <Link to="/" className="flex items-center gap-2">
            <img src={UGL_LOGO} alt="UGL" className="w-7 h-7 object-contain" />
            <span className="font-semibold text-white text-sm hidden sm:block" style={{ fontFamily: 'Outfit, sans-serif' }}>UGL Lariano</span>
          </Link>
          <div className="flex items-center gap-3">
            <span className="text-xs text-[#C9A84C] font-semibold hidden sm:block">Simulatore Bonus Italia 2026</span>
            <Link to="/">
              <Button variant="ghost" size="sm" className="text-white/60 hover:text-white hover:bg-white/5 h-8 px-3 text-xs">
                <ArrowLeft className="w-3.5 h-3.5 mr-1" /> Home
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Iframe pieno */}
      <iframe
        src="/bonus.html"
        title="Simulatore Bonus Italia 2026"
        className="flex-1 w-full border-0"
        data-testid="bonus-iframe"
        allow="clipboard-write"
      />
    </div>
  );
}
